import { ReactNode } from "react";

interface IProps {
  content: ReactNode | Nude;
  classNameAdd?: string;
  width?: number;
  pos?: number[];
  children: ReactNode
}


export const ToolTip: React.FC<IProps> = (props): JSX.Element | null => {

  let x = -18
  let y = 0;
  try { x = props.pos!![0]; y = props.pos!![1]; }catch(e) { }
 


  return (<>
    <div 
      className="group relative flex z-99"
    >
      {props.children}
      {
        (props.content != null && props.content != undefined) ?
          <span 
            className={`absolute top-10 scale-0 transition-all rounded bg-gray-800 p-2 text-xs text-white group-hover:scale-100 ${props.classNameAdd?props.classNameAdd:""}`}
            style={{"width":`${(props.width?props.width:15).toString()}rem`,"left":`${x.toString()}rem`,"top":`${y.toString()}rem`}}
            
            >
            {props.content}
          </span> : <></>
      }
    </div>
  </>
  )
}

